import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import { useDeleteComment } from "../../redux/actions/postAction";

const CommentItem = ({
  comment: { _id, text, name, avatar, user, date },
  postId,
}) => {
  const deleteComment = useDeleteComment();
  const auth = useSelector((state) => state.auth);
  return (
    <div className="comments">
      <div className="post bg-white p-1 my-1">
        <div>
          <Link to={`/profile/${user}`}>
            <img className="round-img" src={avatar} alt="" />
            <h4>{name}</h4>
          </Link>
        </div>
        <div>
          <p className="my-1">{text}</p>
          <p className="post-date">
            Posted on <Moment format="YYYY/MM/DD">{date}</Moment>
          </p>
          {!auth.loading && user === auth.user._id && (
            <button
              onClick={(e) => deleteComment(postId, _id)}
              type="button"
              className="btn btn-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommentItem;
